import React from 'react';

import Promo from './Promo';

// ContentColumn is the main area of every page: the page's own card, with the
// promo card next to it on desktop.
export default function ContentColumn({ className, children }) {
  return (
    <div className={['column content', className].filter(Boolean).join(' ')}>
      {children}
      <Promo />
    </div>
  );
}
